import { useState, useEffect } from 'react'
import { generateRandomCheckoutId } from '../utils'

/**
 * Хук для генерации и хранения случайного ID бронирования
 * @param {any[]} dependencies - Массив зависимостей для useEffect
 * @returns {string | null} Случайный ID бронирования или null в случае ошибки
 */
export const useRandomCheckoutId = (dependencies: any[] = []): string | null => {
  const [checkoutId, setCheckoutId] = useState<string | null>(null)

  useEffect(() => {
    try {
      const id = generateRandomCheckoutId()
      setCheckoutId(id)
    } catch (error) {
      console.error('Ошибка при генерации checkoutId:', error)
    }
  }, [...dependencies])

  return checkoutId
}
